export interface IRecipientMedicalDetails {
    birthDate: string,
    birthYear: number,
    isOnDialysis: boolean,
    bloodType: string,
    dialysisStartDate: string,
    antiATiter: number,
    antiATiterValue: number,
    isAboConfirmed: boolean,
    height: number,
    heightInches: number,
    weight: number,
    weightLbs: number,
    reasonForKidneyFailure: string,
    ebv: string,
    gender: string,
    cmv: string,
    race: string,
    unosDate: string,
    medComments: string,
    hasDiabetes: boolean,
    histogeneticsAbo: string
}

export interface IRecipientMedicalDetailsRequest {
    birthDate: string,
    isOnDialysis: boolean,
    bloodType: string,
    dialysisStartDate: string,
    antiATiter: number,
    antiATiterValue: number,
    isAboConfirmed: boolean,
    height: number,
    weight: number,
    reasonForKidneyFailure: string,
    ebv: string,
    gender: string,
    cmv: string,
    race: string,
    unosDate: string,
    medComments: string,
    hasDiabetes: boolean
}